import { api } from 'new/api/axios';
import { createEndpoint } from 'new/api/utils';
import { DisputesResponse } from './types';

export const getDisputes = createEndpoint<DisputesResponse, unknown>({
  url: '/office/:id/disputes',
  endpoint: ({ url }) => api.get(url),
});
